import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import { GetNtxPeoplesList } from '../../../store/NTX/Peoples/peoplesSlice';
import useGetOrganizations from '../../../hooks/HR/use-get-organizations';
import { GetEquipmentsModelList } from '../../../store/FLEET/EquipmentsModel/equipmentsmodelSlice';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import { GetEquipmentsList, InsertEquipments } from '../../../store/FLEET/Equipments/equipmentsSlice';
import { GetEngineStatues } from '../../../store/Lookup/lookupSlice';
import { EquipmentsSchema } from '../../ValidationForm/validationSchema';
import ExtraInformationBuilderAdd from '../../ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd';
import useGetColumnByTableId from '../../../hooks/Forms/useGetColumnByTableId';
import useAddUpdateExtraInformation from '../../ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation';

interface Props {
  isAme?: boolean;
  setReferenceId?: React.Dispatch<React.SetStateAction<string>>;
}
//
const FormAddEquipments = ({ isAme = false, setReferenceId }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [extraInfoFormData, setExtraInfoFormData] = useState({});

  useEffect(() => {
    dispatch(GetNtxPeoplesList(''));
    dispatch(GetEquipmentsModelList());
    dispatch(GetEngineStatues());
  }, []);

  const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();

  const { PeoplesList } = useAppSelector(state => state.Peoples);
  const { EquipmentsModelList } = useAppSelector(state => state.EquipmentsModel);
  const { EngineStatues } = useAppSelector(state => state.Lookup);
  const { Organizations } = useGetOrganizations();

  //__________ جلب حقول المعلومات الإضافية ان وجدت __________
  const TableId = '85d9908f-3d3f-45fc-ac73-4b72164a3f65'; // جدول معدات الأسطول id
  const { FormColumnByTableIdList, loading } = useGetColumnByTableId(TableId);
  //_________________________________________________________

  const formik = useFormik({
    initialValues: {
      name: '',
      name2: '',
      description: '.',
      fleetModelId: '',
      plateNo: '',

      plateNoArabic: '',
      plateNoEnglish: '',

      serialNo: '',
      chassisNo: '',
      engineStatus: '',
      code: '',
      barcode: '',
      odometer: 0,
      organizationId: '',
      serviceDate: '',
      dateOfExpiry: '',
      purchasePrice: 0,
      ownerId: '',
      lastmaintenanceDate: '',
      driverId: '',
      Img: '',
      IsAddIMG: false,
      extraInformationId: null,
      IsAme: false
    },
    validationSchema: EquipmentsSchema(t),
    onSubmit: async values => {
      var extraInformationId;
      if (FormColumnByTableIdList?.columnList?.length > 0) {
        extraInformationId = await AddUpdateExtraInformation(extraInfoFormData);
      }
      if (FormColumnByTableIdList?.columnList?.length > 0 && extraInformationId === null) {
        CustomAlert({ action: 'Error', msg: 'حدث خطأ' });
        return;
      }

      const formData = new FormData();
      formData.append('ExtraInformationId', extraInformationId);
      formData.append('IsAme', isAme.toString());
      formData.append('Name', values.name);
      formData.append('Name2', values.name2);
      // formData.append('Description', values.description );
      formData.append('Description', '.');
      formData.append('FleetModelId', values.fleetModelId);
      formData.append('PlateNo', values.plateNo);
      formData.append('SerialNo', values.serialNo);
      formData.append('ChassisNo', values.chassisNo);
      formData.append('EngineStatus', values.engineStatus);
      formData.append('Code', values.code);
      formData.append('Barcode', values.barcode);
      formData.append('Odometer', values.odometer.toString());
      formData.append('OrganizationId', values.organizationId);
      formData.append('ServiceDate', values.serviceDate);
      formData.append('DateOfExpiry', values.dateOfExpiry);
      formData.append('PurchasePrice', values.purchasePrice.toString());
      formData.append('OwnerId', values.ownerId);
      formData.append('LastmaintenanceDate', values.lastmaintenanceDate);
      formData.append('DriverId', values.driverId);
      formData.append('Img', values.Img);
      // formData.append("IsAddIMG", values.IsAddIMG);
      formData.append('IsAddIMG', values.IsAddIMG.toString());

      dispatch(InsertEquipments(formData))
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            if (setReferenceId && isAme === true) {
              console.log('setReferenceId', res.data?.id);
              setReferenceId(res.data?.id);
            }

            if (isAme === false) {
              CustomAlert({ action: 'Add' });
              formik.resetForm();
            }

            // document.getElementById('closeModalForm')?.click();

            dispatch(GetEquipmentsList());
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const handleImageUpload = (event: any) => {
    formik.setFieldValue('Img', event.currentTarget.files[0]);
    formik.setFieldValue('IsAddIMG', true);
  };

  return (
    <>
      {/* <Form onSubmit={formik.handleSubmit}> */}
      {/* المعلومات الأساسية للمعدة (تظهر أولاً لأنها الأكثر أهمية وتمثل الهوية الأساسية للمعدة): */}

      <div className='row'>
        <div className='col-xl-2'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('AssetNumber')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='code'
              onChange={formik.handleChange}
              value={formik.values.code}
              isInvalid={!!(formik.touched.code && formik.errors.code)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.code}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-5'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('LocalName')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='name2'
              onChange={formik.handleChange}
              value={formik.values.name2}
              isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-5'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('GlobalName')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='name'
              onChange={formik.handleChange}
              value={formik.values.name}
              isInvalid={!!(formik.touched.name && formik.errors.name)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'> {t('Model')}</label>
            <Form.Select
              className='form-select'
              name='fleetModelId'
              onChange={formik.handleChange}
              value={formik.values.fleetModelId || ''}
              isInvalid={!!(formik.touched.fleetModelId && formik.errors.fleetModelId)}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {EquipmentsModelList &&
                EquipmentsModelList?.filter(f => f.parentId !== null)?.map((item, idx) => (
                  <option key={++idx} value={item.id}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
            {formik.errors.fleetModelId && formik.touched.fleetModelId && <div>{formik.errors.fleetModelId}</div>}
          </div>
        </div>
        {/* تفاصيل التعريف الفنية (تفاصيل تقنية محددة للمعدة): */}
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Plate_Number')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='plateNo'
              onChange={formik.handleChange}
              // onChange={handlePlateNoChange}
              value={formik.values.plateNo}
              isInvalid={!!(formik.touched.plateNo && formik.errors.plateNo)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.plateNo}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Serial_Number')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='serialNo'
              onChange={formik.handleChange}
              value={formik.values.serialNo}
              isInvalid={!!(formik.touched.serialNo && formik.errors.serialNo)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.serialNo}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Chassis_Number')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='chassisNo'
              onChange={formik.handleChange}
              value={formik.values.chassisNo}
              isInvalid={!!(formik.touched.chassisNo && formik.errors.chassisNo)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.chassisNo}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Barcode')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='barcode'
              onChange={formik.handleChange}
              value={formik.values.barcode}
              isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
          </div>
        </div>
        {/* حالة المعدة والتشغيل (معلومات تتعلق بالحالة التشغيلية) */}
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'> {t('Engine_Status')}</label>
            <Form.Select
              className='form-select'
              name='engineStatus'
              onChange={formik.handleChange}
              value={formik.values.engineStatus || ''}
              isInvalid={!!(formik.touched.engineStatus && formik.errors.engineStatus)}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {EngineStatues &&
                EngineStatues?.map((item: any, idx) =>
                  item.list?.map((list: any) => (
                    <option key={++idx} value={list.lookupCode}>
                      {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                    </option>
                  ))
                )}
            </Form.Select>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'> {t('Odometer')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='odometer'
              onChange={formik.handleChange}
              value={formik.values.odometer}
              isInvalid={!!(formik.touched.odometer && formik.errors.odometer)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.odometer}</Form.Control.Feedback>
          </div>
        </div>
        {/* المعلومات التنظيمية والإدارية (معلومات تخص الملكية والتنظيم): */}
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'> {t('Branch')}</label>
            <Form.Select
              className='form-select'
              name='organizationId'
              onChange={formik.handleChange}
              value={formik.values.organizationId || ''}
              isInvalid={!!(formik.touched.organizationId && formik.errors.organizationId)}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {Organizations &&
                Organizations?.filter((f: any) => f.type === '150')?.map((item: any, idx: number) => (
                  <option key={++idx} value={item.id}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'> {t('Owner')}</label>
            <Form.Select
              className='form-select'
              name='ownerId'
              onChange={formik.handleChange}
              value={formik.values.ownerId || ''}
              isInvalid={!!(formik.touched.ownerId && formik.errors.ownerId)}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {PeoplesList &&
                PeoplesList?.filter(f => f.typeCode === 'OWNERS')?.map((item, idx) => (
                  <option key={++idx} value={item.id}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'> {t('Driver')}</label>
            <Form.Select
              className='form-select'
              name='driverId'
              onChange={formik.handleChange}
              value={formik.values.driverId || ''}
              isInvalid={!!(formik.touched.driverId && formik.errors.driverId)}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {PeoplesList &&
                PeoplesList?.filter(f => f.typeCode === 'DRIVERS')?.map((item, idx) => (
                  <option key={++idx} value={item.id}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
          </div>
        </div>

        {/* التواريخ والصيانة (معلومات زمنية تتعلق بالصيانة والتسجيل): */}
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('ServiceDate')}</label>
            <Form.Control
              className='form-control'
              type='date'
              name='serviceDate'
              onChange={formik.handleChange}
              value={formik.values.serviceDate}
              isInvalid={!!(formik.touched.serviceDate && formik.errors.serviceDate)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.serviceDate}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('dateOfExpiry')}</label>
            <Form.Control
              className='form-control'
              type='date'
              name='dateOfExpiry'
              onChange={formik.handleChange}
              value={formik.values.dateOfExpiry}
              isInvalid={!!(formik.touched.dateOfExpiry && formik.errors.dateOfExpiry)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.dateOfExpiry}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('LastMaintenanceDate')}</label>
            <Form.Control
              className='form-control'
              type='date'
              name='lastmaintenanceDate'
              onChange={formik.handleChange}
              value={formik.values.lastmaintenanceDate}
              isInvalid={!!(formik.touched.lastmaintenanceDate && formik.errors.lastmaintenanceDate)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.lastmaintenanceDate}</Form.Control.Feedback>
          </div>
        </div>

        {/* المعلومات المالية (تكلفة الشراء، عادةً أقل أولوية من المعلومات التشغيلية): */}
        <div className='col-xl-3'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Purchase_Price')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='purchasePrice'
              onChange={formik.handleChange}
              value={formik.values.purchasePrice}
              isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.purchasePrice}</Form.Control.Feedback>
          </div>
        </div>
        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Image_of_Equipment')}</label>
            <Form.Control
              className='form-control'
              type='file'
              name='Img'
              accept='image/*'
              onChange={e => handleImageUpload(e)}
              isInvalid={!!(formik.touched.Img && formik.errors.Img)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.Img}</Form.Control.Feedback>
          </div>
        </div>
      </div>

      <div className='rounded-2 p-3 mb-3 border border-theme'>
        <div className='d-flex align-items-center mb-3'>
          <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
          <h5 className='mb-0'>{t('ExtraInformation')}</h5>
        </div>
        {loading && (
          <div className='text-center'>
            <div className='spinner-grow spinner-grow-sm text-primary me-1'></div>
            <div className='spinner-grow spinner-grow-sm text-secondary me-1'></div>
            <div className='spinner-grow spinner-grow-sm text-success me-1'></div>
          </div>
        )}
        {FormColumnByTableIdList?.columnList?.length > 0 && (
          <ExtraInformationBuilderAdd
            FormColumnList={FormColumnByTableIdList}
            isloading={loading}
            moduleId='0a6c6b89-1d52-4eaa-8d2c-040c74b1f6e0' // moduleId  Fleet
            setExtraInfoFormData={setExtraInfoFormData}
          />
        )}
      </div>

      {/* ////////////_________________________ */}

      <div className='text-center'>
        <div className='d-flex justify-content-between gap-2'>
          <button
            disabled={formik.isSubmitting}
            type='button'
            onClick={formik.submitForm}
            className='btn btn-lg btn-theme rounded-1 mb-1 w-100'
          >
            {formik.isSubmitting ? (
              <div className='spinner-border spinner-border-sm me-2'></div>
            ) : (
              <i className='fas fa-save fa-lg fa-fw me-2'></i>
            )}
            {t('Add')}
          </button>
          {!isAme && (
            <button
              type='button'
              className='btn btn-lg rounded-1 btn-default mb-1 w-100'
              data-bs-dismiss='modal'
              id='closeModalForm'
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          )}
        </div>
      </div>
      {/* </Form> */}
    </>
  );
};

export default FormAddEquipments;
